// *******************************************************************************
// Form handling
// *******************************************************************************

const handleForm = (form, formAction) => {
  const formParent = form.closest('[data-parent]');
  const submitBtn = form.querySelector('.form-component__submit .btn');

  if (!formParent) {
    return;
  }

  const parentSection = form.closest('.sc-general');
  const formAlertError = formParent.querySelector('.form-component__alert-error');

  const emailError = getEmailError(form);
  const emailFields = formParent.querySelectorAll('input[type="email"]');

  const fieldValidators = {};
  emailFields.forEach((field) => {
    const fieldName = field.name;

    if (fieldName) {
      fieldValidators[fieldName] = {
        validators: {
          callback: {
            message: emailError,
            callback(input) {
              return validateEmail(input.value);
            },
          },
        },
      };
    }
  });

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: fieldValidators,
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.dropdown,.radio-button,.upload-box'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      excluded: new FormValidation.plugins.Excluded(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(
          e.element,
          '.mod-input, .checkbox, .dropdown, .radio-button,.upload-box',
        );
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      const formType = form.querySelector('[data-form-type]')?.value;
      const formValue = getFormValue(form, fv);

      // pushToDataLayer({
      //   event: 'form_submit',
      //   form_info: {
      //     form_id: formType,
      //     form_name: formType,
      //   },
      //   form_fields: JSON.parse(formValue.inputs.replaceAll(`${formType.replaceAll('-', '_')}_`, '')),
      // });

      grecaptcha.ready(async () => {
        submitBtn.disabled = true;
        formParent.classList.add('show-loader');
        try {
          const files = {};
          let index = 1;

          Object.values(filesToUpload).forEach((fileArray) => {
            fileArray.forEach((fileObj) => {
              files[`files_${index++}`] = fileObj.file;
            });
          });

          await onFormSubmit({
            formData: {
              ...formValue,
              ...files,
              id: localData.id,
              lang: localData.lang,
              formType,
              houseSlug: form.querySelector('[data-house-slug]')?.value,
            },
            recaptchaKey: form.querySelector('[data-sitekey]')?.dataset.sitekey,
            recaptchaAction: formAction,
          });

          formParent.classList.remove('show-loader');
          formParent.classList.add('show-thankyou');

          if (parentSection) {
            parentSection.classList.add('show-thankyou');
            const scrollPosition = parentSection.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: scrollPosition - getHeaderHeight(),
              behavior: 'smooth',
            });
          }
        } catch (error) {
          console.error(error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response.data.data.msg;
        }
        submitBtn.disabled = false;
      });
    });
};

document.addEventListener('DOMContentLoaded', () => {
  ['form_component', 'inquiry_form', 'contact_form', 'sponsorship_form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]')?.value;
      handleForm(form, formAction);
    }
  });
});

// Handle grouped inputs (radio/checkbox groups)
document.querySelectorAll('[data-input-group-parent]').forEach((group) => {
  const fields = group.querySelectorAll('[data-input-group-field]');
  if (fields.length <= 1) return;

  // Watch validation class changes
  const observer = new MutationObserver(() => {
    const hasError = [...group.querySelectorAll('[data-input-group-item]')].some((item) =>
      item.classList.contains('is-validation-failed'),
    );

    group.classList.toggle('failed', hasError);
  });

  fields.forEach((field) => {
    const wrapper = field.closest('[data-input-group-item]');
    if (wrapper) {
      observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    }
  });

  // Add shared error message for input-group style
  if (!group.classList.contains('input-group')) return;

  const errorSource = group.querySelector('[data-fv-not-empty___message]');
  if (!errorSource) return;

  const message = document.createElement('div');
  message.className = 'fv-plugins-message-container group-error';
  message.innerHTML = errorSource.dataset.fvNotEmpty___message;

  group.appendChild(message);
});

// ============================================================================
// TOGGLE FIELDS
// ============================================================================

document.addEventListener('DOMContentLoaded', () => {
  const toggle = (el, cls, state) => el?.classList.toggle(cls, state);
  const setupToggleFields = () => {
    document.querySelectorAll('[data-toggle-field]').forEach((field) => {
      const target = document.querySelector(`[data-field="${field.dataset.toggleField}"]`);
      if (!target) return;

      const update = () => {
        const checked = document.querySelector(`[name="${field.name}"]:checked`);
        toggle(target, 'hide', checked !== field);
      };

      document.querySelectorAll(`[name="${field.name}"]`).forEach((r) => r.addEventListener('change', update));

      update();
    });
  };

  setupToggleFields();
});
